/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { ErrorPage } from './error-page';
import { posthog } from 'posthog';
// eslint-disable-next-line react/require-optimization
export class ErrorsInterceptor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false
        };
    }
    componentDidCatch(error, errorInfo) {
        posthog.captureException(error, { errorInfo });
        // eslint-disable-next-line react/no-set-state
        this.setState({ error: true });
    }
    render() {
        if (this.state.error) {
            return React.createElement(ErrorPage, null);
        }
        return this.props.children;
    }
}
